import { DatePipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';
import { DateFormat, DateTimezone } from '@shared/enums/common-data/date-format.enum';
import { DateUtils } from '@shared/utils/date/date-utils.service';

@Pipe({
  name: 'dateXpo'
})
export class DateXpoPipe implements PipeTransform {

  constructor(private angularDatePipe: DatePipe) {}

  transform(date: string | number, timeZone = DateTimezone.local): string | null {
    return typeof date === 'number' ? this.transformNumber(date, timeZone) : this.transformString(date);
  }

  private transformNumber(datetime: number, timeZone: DateTimezone): string {
    if (datetime == null) return '';
    return DateUtils.getDateFromTimeStamp(datetime, DateFormat.defaultScreenDate, timeZone);
  }

  private transformString(date: string): string | null {
    if (!date) return '';
    return this.angularDatePipe.transform(date, 'MM/dd/yyyy');
  }

}
